module.exports = __webpack_public_path__ + "img/obencard.a764ac49.png";